import {ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';

@Component({
    selector: 's-range-localtime-slider',
    templateUrl: './range-localtime-slider.component.html',
    styleUrls: ['./range-localtime-slider.component.scss']
    // changeDetection: ChangeDetectionStrategy.OnPush
    ,
    standalone: false
})
export class RangeLocaltimeSliderComponent implements OnInit, OnChanges {
  @Input() rangeValues;
  @Input() rangeLimitValues;
  @Input() realWidth = 100;
  @Input() limitType: string;
  @Input() leftLabelValue;
  @Input() rightLabelValue;
  @Input() minValue = 0;
  @Input() maxValue = 1000;
  @Input() disabled = false;
  @Input() limitLabels = ['', ''];

  @Output() changeLabels = new EventEmitter<any>();
  public leftHandleRangeStyle = {};
  public rightHandleRangeStyle = {};
  public leftLimitStyle = {};
  public rightLimitStyle = {};
  public showLeftLimit = true;
  public showRightLimit = true;

  constructor(private cb: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.calcFromLabels();
    this.calcMarginsAndLimits();
  }

  ngOnChanges(data) {
    this.calcFromLabels();
    this.calcMarginsAndLimits();
    setTimeout(() => this.cb.markForCheck(), 0);

  }

  public calcFromLabels() {
    this.rangeValues = [
      this.leftLabelValue,
      this.rightLabelValue
    ];
    if (this.rangeValues[0] > this.rangeValues[1]) {
      const tmp = this.rangeValues[0];
      this.rangeValues[0] = this.rangeValues[1];
      this.rangeValues[1] = tmp;
    }
  }

  public triggerChangeLabels() {
    this.changeLabels.emit([this.leftLabelValue, this.rightLabelValue]);
  }

  /**
   * Увеличивает указанную метку на единицу
   * @param labelName
   */
  public incLabel(labelName) {
    this[labelName] += this[labelName] === this.maxValue ? 0 : 1;
    this.calcFromLabels();
    this.triggerChangeLabels();
  }

  /**
   * Уменьшает указанную метку на единицу
   * @param labelName
   */
  public decLabel(labelName) {
    this[labelName] -= this[labelName] === this.minValue ? 0 : 1;
    this.calcFromLabels();
    this.triggerChangeLabels();
  }

  /**
   * Расчитать реальные смещения после обновления данных
   */
  public calcMarginsAndLimits() {
    this.leftLimitStyle['margin-left'] = (this.rangeLimitValues[0] * (this.realWidth / this.maxValue)) + '%';
    this.rightLimitStyle['margin-left'] = (this.rangeLimitValues[1] * (this.realWidth / this.maxValue)) + '%';

    this.leftHandleRangeStyle['left'] = (this.rangeValues[0] * (this.realWidth / this.maxValue) - 0.5) + '%';
    this.rightHandleRangeStyle['left'] = (this.rangeValues[1] * (this.realWidth / this.maxValue)) + '%';
    this.rightHandleRangeStyle['margin-top'] = '-2.5em';

    this.leftLabelValue = this.rangeValues[0];
    this.rightLabelValue = this.rangeValues[1];
  }
}
